import axios from 'axios';
import TokenService from '@/services/TokenService';

const validateStatus = status => (status < 400);

export default {
  async getPolicyBalanceInfo(policyNumber, zipCode) {
    return TokenService.getPolicyZipToken(policyNumber, zipCode)
      .then(bearerToken => {
        return axios({
          method: 'GET',
          url: `${process.env.V1_POLICY_BALANCES}/${policyNumber}`,
          headers: {
            authorization: `Bearer ${bearerToken}`
          },
          validateStatus
        });
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/PolicyService.js